'use client'

import { Button } from '@mui/material'

// Types
import type { FeedbackButtonProps } from '@/types/components/atoms/buttons/feedback'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

const FeedbackButton = (props: FeedbackButtonProps) => {
	// Props
	const { title, lng, onClick } = props

	// Variables
	const { t } = useTranslation(lng)

	return (
		<Button
			variant="contained"
			disableElevation
			onClick={onClick}
			sx={{
				mb: 5,
				py: 1.625,
				px: 3,
				position: 'fixed',
				right: 0,
				bottom: 0,
				lineHeight: 1,
				color: 'common.white',
				bgcolor: 'primary.main',
				borderBottomLeftRadius: 0,
				borderBottomRightRadius: 0,
				transform: 'rotate(270deg) translate(50px, 31.5px)',
				zIndex: 'calc(var(--mui-zIndex-tooltip) + 1)'
			}}
		>
			{t(title)}
		</Button>
	)
}

export default FeedbackButton
